const comps = import.meta.glob("../../components/modals/**/*.vue");

/**
 * This will lazy load a modal component
 *
 * @param {String} view The file path of the modal component
 * @returns Asynchronous modal component
 */
export default function (view) {
  return comps[`../../components/modals/${view}.vue`];
}
